import CollaboAdminModal from './CollaboAdminModal';

export default CollaboAdminModal;
